import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { Box, Text } from "@chakra-ui/react";
import Loader from "../Loader/Loader";

function generateColors(currentUserId, finalData) {
  const colors = [];
  for (let i = 0; i < finalData.length; i++) {
    if (finalData[i].id === currentUserId) {
      colors.push("#30d5c8");
    } else {
      colors.push(`rgba(169, 169, 169, ${0.5 + i * 0.1})`);
    }
  }
  return colors;
}

const RelativeMarketShare = () => {
  const { loading: clientLoading, data: clientData } = useSelector(
    (state) => state.clientReducer
  );
  const { loading: clientClusterWiseLoading, data: clientClusterWiseData } =
    useSelector((state) => state.clientClusterWiseReducer);

  const { clusterWiseData = [], totalRevenueFromOperationOfPeers } =
    clientClusterWiseData || {};

  const [years, setYears] = useState([]);

  useEffect(() => {
    if (!clientLoading && clientData) {
      setYears(clientData?.auditUploadYears);
    }
  }, [clientLoading]);

  const chartData2 = Object.values(
    clusterWiseData
      ?.filter((company) => company.financialMetrics.length > 0)
      ?.reduce?.((accum, company) => {
        const obj = {};

        obj["id"] = company.id;
        obj["companyName"] = company.companyName;

        const relativeShare = company.financialMetrics.map((item) => {
          const xVal =
            item.revenueFromOperations /
            totalRevenueFromOperationOfPeers[item.year];

          return xVal;
        });

        obj["relativeShare"] = relativeShare;

        accum[company.id] = accum[company.id] || obj;

        return accum;
      }, {})
  );

const chartOptions = {
  chart: {
    type: "bar",
    stacked: true,
    stackType: "100%",
    height: 350,
    toolbar: {
      show: true,
    },
  },
 grid: {
  show: false,
  padding: {
    left: 0,
    right: 0,
  },
},

  tooltip: {
    enabled: true,
  },
  legend: {
    show: false,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "80%",
      barHeight: '100%',
    },
  },
  yaxis: {
    labels: {
      formatter: function (value) {
        return value ? `${Math.abs(value)}%` : value;
      },
    },
  },
 xaxis: {
  categories: years,
  axisTicks: { show: false },
  axisBorder: { show: false },
  labels: {
    offsetX: 4, // pushes label slightly to right (adjust as needed)
  },
  rangePadding: 10, // adds padding between the bars (simulated spacing)
},

  fill: {
    opacity: 1,
  },
  colors: generateColors(clientData?._id, chartData2),
};



  const chartSeries = chartData2.map((data) => {
    return {
      name: data.companyName,
      data: data.relativeShare.map((share) => share),
    };
  });
  return (
    <div w="100%" overflowX="auto">
      {clientClusterWiseLoading ? (
        <>
          <Box h={"200px"} >
            <Loader />
          </Box>
        </>
      ) : (
        <>
          <Text textTransform="uppercase" fontWeight={600} fontSize={18}>
            Relative Market Share
          </Text>
          <Box py={6} minW="550px">
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="bar"
              height={350}
            />
          </Box>
        </>
      )}
    </div>
  );
};

export default RelativeMarketShare;
